module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_26_D_1.8750eb37.mp3";